import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { setUser } from "../redux/features/userSlice.js";
import { message } from "antd";
import Layout from "../components/Layout/Layout";
import axios from "axios";
import getUserData from "../utils/userDataService.js";

// ICON
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import VerifiedIcon from "@mui/icons-material/Verified";
import BoltIcon from "@mui/icons-material/Bolt";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import SearchIcon from "@mui/icons-material/Search";
import website from "../website/data.js";

// CSS
import "./ProductInfo.css";
import "./PackAmount.css";
import "./Spinner.css";
import "./OrderSuccess.css";

const ProductInfo = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const paymentRef = useRef(null);
  const { pathname } = useLocation();

  const handleScrollToPayment = () => {
    if (paymentRef.current) {
      paymentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const { user } = useSelector((state) => state.user);
  const [checkBox, setCheckBox] = useState(false);
  const [playerCheck, setPlayerCheck] = useState(null);

  // Updated state for new backend
  const [gameData, setGameData] = useState(null);
  const [diamondPacks, setDiamondPacks] = useState([]);
  const [filteredDiamondPacks, setFilteredDiamondPacks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("diamonds");
  const [selectedPack, setSelectedPack] = useState(null);
  const [selectedPackId, setSelectedPackId] = useState("");
  const [showImage, setShowImage] = useState(0);
  const [error, setError] = useState(false);
  const [quantity, setQuantity] = useState(1);

  //! API BASED
  const [orderId, setOrderId] = useState(false);
  const [playerId, setPlayerId] = useState("");
  const [server, setServer] = useState("");
  const [balance, setBalance] = useState("");

  // Genshin Impact server list
  const genshinServers = [
    { code: "os_asia", name: "Asia" },
    { code: "os_euro", name: "Europe" },
    { code: "os_usa", name: "USA" },
    { code: "os_cht", name: "TW, HK, MO USA" }
  ];

  // loading
  const [loading, setLoading] = useState(false);
  const [playerValidationLoading, setPlayerValidationLoading] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [readMore, setReadMore] = useState(false);

  // coupon - keeping existing coupon functionality
  const [coupon, setCoupon] = useState(null);
  const [couponId, setCouponId] = useState("");
  const [couponApplied, setCouponApplied] = useState(null);
  const [discount, setDiscount] = useState("");
  const [finalAmount, setFinalAmount] = useState("");
  const [couponName, setCouponName] = useState("");

  // payment mode
  const [mode, setMode] = useState("WALLET");

  // Base URL for new backend
  const BASE_URL = "https://api.zorotopup.com";

  useEffect(() => {
    getUserData(dispatch, setUser, setBalance);
    getAllCoupons();
  }, []);

  const ScrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
  };

  // Keep existing coupon functionality
  const getAllCoupons = async () => {
    try {
      const res = await axios.get("/api/admin/get-coupons");
      if (res.data.success) {
        // setData(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(gameData);


  // Updated function to fetch diamond packs for a game
  const getDiamondPacks = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${BASE_URL}/api/v1/games/${params.gameId}/diamond-packs`);

      if (res.data.success) {
        // Filter active products and sort by amount (small to high)
        const activePacks = res.data.diamondPacks
          .filter(pack => pack.status === "active")
          .sort((a, b) => a.amount - b.amount);
        
        setDiamondPacks(activePacks);
        setFilteredDiamondPacks(activePacks);
        setGameData(res.data.gameData);

        // Extract unique categories from active packs only
        const uniqueCategories = [...new Set(activePacks.map(pack => pack.category?.toLowerCase()).filter(Boolean))];
        // Only show category filter if there are actual categories
        if (uniqueCategories.length > 0) {
          setCategories(uniqueCategories);
        } else {
          setCategories([]); // No categories to filter by
        }

        // Set default selected pack (first pack from diamonds category or first available)
        if (activePacks.length > 0) {
          let defaultPack;
          // Try to find a diamonds pack first
          const diamondsPacks = activePacks.filter(pack => pack.category?.toLowerCase() === 'diamonds');
          if (diamondsPacks.length > 0) {
            defaultPack = diamondsPacks[0];
          } else {
            // Fallback to first available pack
            defaultPack = activePacks[0];
          }
          setSelectedPack(defaultPack);
          setSelectedPackId(defaultPack._id);
          setFinalAmount(calculatePackPrice(defaultPack));
        }
      } else {
        message.error("Failed to load diamond packs");
      }
    } catch (error) {
      console.log(error);
      message.error("Error loading diamond packs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (params.gameId) {
      getDiamondPacks();
    }
  }, [params.gameId]);

  // Filter diamond packs based on selected category
  useEffect(() => {
    const filtered = diamondPacks
      .filter(pack => pack.category?.toLowerCase() === selectedCategory)
      .sort((a, b) => a.amount - b.amount); // Maintain sorting by amount
    setFilteredDiamondPacks(filtered);
  }, [selectedCategory, diamondPacks]);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    // Reset selected pack when changing category
    const filteredPacks = diamondPacks
      .filter(pack => pack.category?.toLowerCase() === category)
      .sort((a, b) => a.amount - b.amount); // Sort by amount
    if (filteredPacks.length > 0) {
      const defaultPack = filteredPacks[0]; // First pack after sorting
      setSelectedPack(defaultPack);
      setSelectedPackId(defaultPack._id);
      setFinalAmount(calculatePackPrice(defaultPack));
    }
  };

  // Calculate pack price (you can add reseller logic here)
  const calculatePackPrice = (pack) => {
    // Add your pricing logic here based on user type
    return pack.amount + pack.commission; // Example calculation
  };

  // Updated player validation function
  const handleCheckPlayer = async () => {
    // Dynamic validation based on gameData.validationFields
    const validationFields = gameData?.validationFields || ["playerId", "server"];
    const missingFields = [];
    
    // Check for required fields dynamically
    if (validationFields.includes("playerId") && playerId === "") {
      missingFields.push("Player ID");
    }
    if (validationFields.includes("server") && server === "") {
      missingFields.push("Server ID");
    }
    
    if (missingFields.length > 0) {
      return message.error(`Please enter: ${missingFields.join(", ")}`);
    }

    try {
      setPlayerValidationLoading(true);
      
      // Build request body dynamically based on validation fields
      const requestBody = {
        game: gameData?.ogcode || "MOBILE_LEGENDS_PRO",
      };
      
      // Add fields based on validationFields using exact field names
      if (validationFields.includes("playerId")) {
        requestBody.playerId = playerId;
      }
      if (validationFields.includes("server")) {
        requestBody.server = server;
      }
      
      const response = await axios.post(`${BASE_URL}/api/v1/games/validate-user`, requestBody);

      console.log("Validate User API Response:", response.data);

      // New response format example:
      // { valid: true, name: "Nadeem", server: "India", msg: "", authenticated: false }
      const result = response.data || {};

      if (result.valid) {
        const nickname = result.name || "Player Found";
        const playerServer = result.server || "Unknown Server";

        const validationText = `${nickname} (${playerServer})`.replace(/\(null\)/g, "");
        setPlayerCheck(validationText);
        // Optional toast if you want it:
        // message.success("Player validated successfully");
      } else {
        message.error(result.msg || "Player not found");
        setPlayerCheck(null);
      }
    } catch (error) {
      console.log(error);
      message.error("Error validating player");
      setPlayerCheck(null);
    } finally {
      setPlayerValidationLoading(false);
    }
  };

  // Updated order placement function
  const checkPlaceOrder = (e) => {
    ScrollToTop();

    // Dynamic validation based on gameData.validationFields
    const validationFields = gameData?.validationFields || ["playerId", "server"];
    const missingFields = [];
    
    // Check for required fields dynamically
    if (validationFields.includes("playerId") && playerId === "") {
      missingFields.push("Player ID");
    }
    if (validationFields.includes("server") && server === "") {
      missingFields.push("Server ID");
    }
    
    if (missingFields.length > 0) {
      return message.error(`Please enter: ${missingFields.join(", ")}`);
    }
    
    if (!selectedPack) {
      return message.error("Select a diamond pack");
    }

    // Check if player validation is required
    if (gameData?.requiresValidation && playerCheck === null) {
      return message.error("Please validate your player first");
    }

    if (mode === "UPI") {
      handleUpiOrder(e);
    } else {
      handleWalletOrder(e);
    }
  };

  // Wallet order (balance purchase)
  const handleWalletOrder = async (e) => {
    if (parseInt(balance) < parseInt(finalAmount)) {
      return message.error("Balance is less for this order");
    }

    e.preventDefault();

    try {
      setLoading(true);
      
      // Build order data dynamically based on validation fields
      const validationFields = gameData?.validationFields || ["playerId", "server"];
      const orderData = {
        diamondPackId: selectedPackId,
        quantity: quantity,
      };
      
      // Add fields based on validationFields
      if (validationFields.includes("playerId")) {
        orderData.playerId = playerId;
      }
      if (validationFields.includes("server")) {
        orderData.server = server;
      }

      const response = await axios.post(`${BASE_URL}/api/v1/order/diamond-pack`, orderData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      if (response.data.success) {
        message.success("Order placed successfully!");
        setOrderSuccess(true);
        setOrderId(response.data.orderId);
        navigate(`/success/${response.data.orderId}`);
      } else {
        message.error(response.data.message);
        navigate("/failure");
      }
    } catch (error) {
      console.log(error);
      message.error("Error placing order");
      navigate("/failure");
    } finally {
      setLoading(false);
    }
  };

  // UPI order
  const handleUpiOrder = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      
      // Build order data dynamically based on validation fields
      const validationFields = gameData?.validationFields || ["playerId", "server"];
      const orderData = {
        diamondPackId: selectedPackId,
        quantity: quantity,
        redirectUrl: `${window.location.origin}/payment-status`,
      };
      
      // Add fields based on validationFields
      if (validationFields.includes("playerId")) {
        orderData.playerId = playerId;
      }
      if (validationFields.includes("server")) {
        orderData.server = server;
      }

      const response = await axios.post(`${BASE_URL}/api/v1/order/diamond-pack-upi`, orderData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      console.log("UPI Order Response:", response.data);

      if (response.data.success && response.data.transaction?.paymentUrl) {
        // Redirect to the payment URL
        window.location.href = response.data.transaction.paymentUrl;
      } else if (response.data.success && response.data.paymentUrl) {
        // Fallback for different response structure
        window.location.href = response.data.paymentUrl;
      } else {
        message.error(response.data.message || "Failed to get payment URL");
      }
    } catch (error) {
      console.log(error);
      message.error("Error initiating payment");
    } finally {
      setLoading(false);
    }
  };

  // Handle pack selection
  const handlePackSelection = (pack) => {
    setSelectedPack(pack);
    setSelectedPackId(pack._id);
    setFinalAmount(calculatePackPrice(pack));
    handleScrollToPayment();

    // Reset coupon if applied
    if (couponApplied) {
      setCouponApplied(false);
      setCouponId("");
    }
  };

  return (
    <Layout>
      {loading ? (
        <div className="loading-container">
          <div className="dot-spinner">
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
          </div>
        </div>
      ) : orderSuccess ? (
        <div className="order-succcess-container">
          <h5>Order Successful</h5>
          <div className="order-recpt">
            <div className="order-item">
              <span>Game Name</span>
              <span>{gameData?.name}</span>
            </div>
            <div className="order-item">
              <span>Order Id</span>
              <span>{orderId}</span>
            </div>
            {/* Dynamic order items based on validationFields */}
            {gameData?.validationFields?.map((field, index) => {
              if (field === "playerId" && playerId !== "") {
                return (
                  <div key={index} className="order-item">
                    <span>Player ID</span>
                    <span>{playerId}</span>
                  </div>
                );
              }
              if (field === "server" && server !== "") {
                return (
                  <div key={index} className="order-item">
                    <span>Server ID</span>
                    <span>{server}</span>
                  </div>
                );
              }
              return null;
            })}
            <div className="order-item">
              <span>Diamond Pack</span>
              <span>{selectedPack?.amount} Diamonds</span>
            </div>
            <div className="order-item">
              <span>Quantity</span>
              <span>{quantity}</span>
            </div>
            <div className="order-item">
              <span>Total Amount</span>
              <span>₹{finalAmount}</span>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="topbanner">
            <div
              className={`p-info-container area loading ${loading && "active"}`}
              style={{
                backgroundImage: gameData?.image
                  ? `url(${gameData.image})`
                  : `url(${website.link}/default-banner.jpg)`,
                backgroundSize: "cover",
                backgroundPosition: "top",
                backgroundRepeat: "no-repeat",
              }}
            ></div>
          </div>

          <div className="productdetails">
            <div className="pro-img">
              {loading ? (
                <div className="imagess"></div>
              ) : (
                <img src={gameData?.image || `${website.link}/default-game.jpg`} alt="" />
              )}
              <div>
                <h2 className={`m-0 loading ${loading && "active"}`} style={{ overflow: "hidden" }}>
                  {gameData?.name}
                </h2>
                <h6 className="m-0 d-none d-md-none d-lg-block">
                  {gameData?.company || "Gaming Company"}
                </h6>
                <div className="features">
                  <button className={`loading ${loading && "active"}`}>
                    <VerifiedIcon className="icon text-primary" />
                    Official Service
                  </button>
                  <button className={`loading ${loading && "active"}`}>
                    <BoltIcon className="icon text-warning" />
                    Instant Process
                  </button>
                  <button className={`loading ${loading && "active"}`}>
                    <VerifiedUserIcon className="icon text-success" />
                    Secure Top-Ups
                  </button>
                  <button className={`loading ${loading && "active"}`}>
                    <SupportAgentIcon className="icon text-info" />
                    24/7 Support
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="product-info-container">
            <div className="product-info-content mb-2">
              {/* CATEGORY FILTER */}
              {categories.length > 1 && (
                <div className="category-filter-section">
                  <h5>Filter by Category</h5>
                  <div className="category-filter">
                    {loading ? (
                      // Loading skeleton for category buttons
                      <>
                        {[1, 2, 3, 4].map((_, index) => (
                          <div key={index} className="category-btn loading-skeleton" />
                        ))}
                      </>
                    ) : (
                      categories.map((category, index) => (
                        <button
                          key={index}
                          className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                          onClick={() => handleCategorySelect(category)}
                        >
                          {category.charAt(0).toUpperCase() + category.slice(1)}
                        </button>
                      ))
                    )}
                  </div>
                </div>
              )}

              {/* DIAMOND PACKS */}
              <div className="packageeeee" >
                <div className="package-container">
                  {filteredDiamondPacks?.length === 0 && !loading ? (
                    <div className="empty-state">
                      <p>No diamond packs found for the selected category.</p>
                      {categories.length > 0 && (
                        <button
                          className="category-btn"
                          onClick={() => handleCategorySelect(categories[0])}
                        >
                          Show {categories[0].charAt(0).toUpperCase() + categories[0].slice(1)} Packs
                        </button>
                      )}
                    </div>
                  ) : (
                    filteredDiamondPacks?.map((pack, index) => (
                      <div
                        key={pack._id}
                        onClick={() => handlePackSelection(pack)}
                        className={`amount ${selectedPackId === pack._id && "active"}`}
                      >
                        <div className="pack-details">
                          <div className="image">
                            <img src={pack.logo} alt="diamond pack" />
                          </div>
                          <div className="pack">
                            <p>{pack.description}</p>
                            <p>Instant Delivery</p>
                            {pack.category && (
                              <p className="pack-category">{pack.category}</p>
                            )}
                          </div>
                          <div className="price">
                            <p>₹{calculatePackPrice(pack)}</p>
                            {pack.originalPrice && (
                              <p className="fakeprice">₹{pack.originalPrice}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>

              {/* DESCRIPTION */}
              <div className="pic d-none d-lg-block">
                <div className="product-info-img bg-fields transparentbg descbg">
                  <div className="game-name">
                    <h4>Description:</h4>
                  </div>
                  {readMore ? (
                    <>
                      <p>{gameData?.description || selectedPack?.description}</p>
                      <span className="text-primary" onClick={() => setReadMore(!readMore)}>
                        <small>Read Less</small>
                      </span>
                    </>
                  ) : (
                    <>
                      <p>{(gameData?.description || selectedPack?.description)?.slice(0, 100)}...</p>
                      <span className="text-primary" onClick={() => setReadMore(!readMore)}>
                        <small>Read More</small>
                      </span>
                    </>
                  )}
                </div>
              </div>

              {/* PLAYER FIELDS */}
              <div className="userfields" ref={paymentRef}>
                <div className="bg-fields transparentbg">
                  <h5>Enter Player Details</h5>
                  <div className="fieldss">
                    {/* Dynamic input fields based on validationFields */}
                    {gameData?.validationFields?.map((field, index) => {
                      if (field === "playerId") {
                        return (
                          <input
                            key={index}
                            className="player-tag"
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            name="playerId"
                            placeholder="Player ID"
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(/\D/g, "");
                              setPlayerId(numericValue);
                            }}
                            value={playerId}
                          />
                        );
                      }
                      if (field === "server") {
                        // Check if it's Genshin Impact for special server handling
                        if (gameData?.ogcode === "GENSHIN_IMPACT") {
                          return (
                            <select
                              key={index}
                              className="player-tag"
                              name="server"
                              onChange={(e) => setServer(e.target.value)}
                              value={server}
                            >
                              <option value="">Select Server</option>
                              {genshinServers.map((serverOption, serverIndex) => (
                                <option key={serverIndex} value={serverOption.code}>
                                  {serverOption.name}
                                </option>
                              ))}
                            </select>
                          );
                        } else {
                          return (
                            <input
                              key={index}
                              className="player-tag"
                              type="text"
                              name="server"
                              placeholder="Server ID"
                              onChange={(e) => setServer(e.target.value)}
                              value={server}
                            />
                          );
                        }
                      }
                      // Handle any other validation fields dynamically
                      return (
                        <input
                          key={index}
                          className="player-tag"
                          type={field === "playerId" ? "tel" : "text"}
                          inputMode={field === "playerId" ? "numeric" : undefined}
                          pattern={field === "playerId" ? "[0-9]*" : undefined}
                          name={field}
                          placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                          onChange={(e) => {
                            // You can add more state variables for other fields as needed
                            if (field === "playerId") {
                              const numericValue = e.target.value.replace(/\D/g, "");
                              setPlayerId(numericValue);
                            }
                            if (field === "server") setServer(e.target.value);
                          }}
                          value={field === "playerId" ? playerId : field === "server" ? server : ""}
                        />
                      );
                    })}
                  </div>
                  {playerValidationLoading && (
                    <p className="playername" style={{ color: '#f59e0b' }}>
                      Validating player...
                    </p>
                  )}
                  {playerCheck !== null && !playerValidationLoading && (
                    <p className="playername">{playerCheck}</p>
                  )}
                  <div className="playercheckbutton">
                    <button 
                      className="buy-now" 
                      onClick={handleCheckPlayer}
                      disabled={playerValidationLoading}
                    >
                      <SearchIcon className="icon" />
                      {playerValidationLoading ? "Validating..." : "Validate Player"}
                      {playerValidationLoading && (
                        <div className="spinner-grow spinner-grow-sm" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              </div>

              {/* PAYMENT METHOD */}
              <div className="paymentsection">
                <div className="bg-fields transparentbg">
                  <h5>Payment Method</h5>
                  <div className="payment-container">
                    <div
                      onClick={() => setMode("WALLET")}
                      className={`payment wallet ${mode === "WALLET" && "active"}`}
                    >
                      Z COINS
                    </div>
                    <div
                      onClick={() => setMode("UPI")}
                      className={`payment upi ${mode === "UPI" && "active"}`}
                    >
                      UPI
                    </div>
                  </div>
                </div>
              </div>

              {/* QUANTITY SELECTION */}
              {/* <div className="quantitysection">
                <div className="bg-fields transparentbg">
                  <h5>Quantity</h5>
                  <div className="quantity-container">
                    <button
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      className="qty-btn"
                    >
                      -
                    </button>
                    <span className="qty-display">{quantity}</span>
                    <button
                      onClick={() => setQuantity(quantity + 1)}
                      className="qty-btn"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div> */}

              {/* ORDER SUMMARY */}
              <div className="totaltable">
                <h5>Order Summary</h5>
                <div className="orderitem">
                  <div className="item">Diamond Pack</div>
                  <div className="item">{selectedPack?.amount || 0} Diamonds</div>
                </div>
                <div className="orderitem">
                  <div className="item">Quantity</div>
                  <div className="item">{quantity}</div>
                </div>
                <div className="orderitem">
                  <div className="item">Total Amount</div>
                  <div className="item">₹{finalAmount * quantity}</div>
                </div>
              </div>

              {user && (
                <div className="eighteenplusconfirmation">
                  <div className="text">
                    <input
                      type="checkbox"
                      className="checkbox"
                      name="check"
                      onChange={() => setCheckBox(!checkBox)}
                    />
                    I, {user?.fname} confirms that I am 18+ age
                  </div>
                  {!checkBox && (
                    <div className="note">
                      Note: Please check the box to continue
                    </div>
                  )}
                </div>
              )}

              <div className="totalsection">
                {!user ? (
                  <button onClick={() => navigate("/login")} className="buy-now">
                    Please Login First
                  </button>
                ) : (
                  <button
                    disabled={!checkBox || !selectedPack}
                    onClick={checkPlaceOrder}
                    className={`buy-now ${(!checkBox || !selectedPack) && "disabled"}`}
                  >
                    Place Order - ₹{finalAmount * quantity}
                  </button>
                )}
              </div>

              {/* MOBILE DESCRIPTION */}
              <div className="pic d-block d-lg-none">
                <div className="product-info-img bg-fields transparentbg descbg">
                  <div className="game-name">
                    <h4>Description:</h4>
                  </div>
                  {readMore ? (
                    <>
                      <p>{gameData?.description || selectedPack?.description}</p>
                      <span className="text-primary" onClick={() => setReadMore(!readMore)}>
                        <small>Read Less</small>
                      </span>
                    </>
                  ) : (
                    <>
                      <p>{(gameData?.description || selectedPack?.description)?.slice(0, 100)}...</p>
                      <span className="text-primary" onClick={() => setReadMore(!readMore)}>
                        <small>Read More</small>
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Layout>
  );
};

export default ProductInfo;